import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components';

export const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-white mb-4">404</h1>
        <p className="text-xl text-gray-400 mb-8">Página não encontrada</p>
        <Link to="/">
          <Button variant="primary">Voltar ao Início</Button>
        </Link>
      </div>
    </div>
  );
};
